import { toastStore } from 'shared/ui'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { PaygLimitModalStore } from 'entities/Subscription/ui/PaygLimitModal'
import { TrialLimitModalStore } from 'entities/Subscription/ui/TrialLimitModal'
import { GoToQuestionnaireModalStore } from 'pages/settings/pages/compliance/ui/GoToQuestionnaireModal'
import { CANCELED_SUBSCRIPTION_TOAST } from 'pages/settings/lib/canceledSubscriptionToast'

function shouldOpenQuestionnaire(entities: IEntitiesStore): boolean {
  const isRestricted = entities.subscriptionStore.isTrial || entities.subscriptionStore.isPAYGPlan
  return (
    isRestricted &&
    !entities.organizationStore.isTwilioNumberVendor &&
    Boolean(entities.usersStore.user?.isRequireNumber)
  )
}

function shouldOpenTrialLimitModal(entities: IEntitiesStore): boolean {
  return (
    entities.subscriptionStore.isTrial &&
    !entities.usersStore.user?.isRequireNumber &&
    entities.usersStore.users.length >= 2
  )
}

function shouldOpenPaygLimitModal(entities: IEntitiesStore): boolean {
  return entities.subscriptionStore.isPAYGPlan && !entities.usersStore.user?.isRequireNumber
}

type IRunBeforeAddMemberOptions = {
  checkCanceled?: boolean
}

export function runBeforeAddMember(
  entities: IEntitiesStore,
  onProceed: () => void,
  options: IRunBeforeAddMemberOptions = {}
): void {
  const { checkCanceled = true } = options

  if (checkCanceled && entities.subscriptionStore.isCanceled) {
    toastStore.add(CANCELED_SUBSCRIPTION_TOAST)
    return
  }
  if (shouldOpenQuestionnaire(entities)) {
    new GoToQuestionnaireModalStore(entities).open('members')
    return
  }
  if (shouldOpenTrialLimitModal(entities)) {
    new TrialLimitModalStore(entities).open('members')
    return
  }
  if (shouldOpenPaygLimitModal(entities)) {
    new PaygLimitModalStore(entities).open('members')
    return
  }
  onProceed()
}
